import React from "react";
import styles from "./ribon.module.scss";
import cx from "classnames";

interface RibonProps {
  size: "medium" | "large";
}

const Ribon: React.FC<RibonProps> = (props) => {
  const { size = "medium" } = props;

  return size === "medium" ? (
    <svg
      className={cx(styles.ribbon)}
      xmlns="http://www.w3.org/2000/svg"
      width="98"
      height="318"
      viewBox="0 0 98 318"
      fill="white"
      stroke="white"
      strokeWidth={3}>
      <path
        d="M0.34375 0.936523H97.7718V312.326C97.7718 316.213 93.8883 318.904 90.2485 317.538L51.0138 302.815C49.7527 302.342 48.3629 302.342 47.1018 302.815L7.86707 317.538C4.22724 318.904 0.34375 316.213 0.34375 312.326V0.936523Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      className={cx(styles.ribbon)}
      xmlns="http://www.w3.org/2000/svg"
      width="138"
      height="446"
      viewBox="0 0 138 446"
      fill="none">
      <path
        d="M0.53125 0.00195312H137.532V437.87C137.532 443.337 132.071 447.12 126.953 445.2L71.7822 424.496C70.0089 423.831 68.0545 423.831 66.2813 424.496L11.1104 445.2C5.99211 447.12 0.53125 443.337 0.53125 437.87V0.00195312Z"
        fill="white"
      />
    </svg>
  );
};

export default Ribon;
